import { JournalType } from "../types";

import BankingTransactionsDetails from "./banking-transactions-details";
import BlockchainTransactionsDetails from "./blockchain-transactions-details";
import BlockchainWithdrawalsDetails from "./blockchain-withdrawals-details";
import FxTicketDetails from "./fx-tickets-details";
import PaymentsDetails from "./payments-details";
import PostingsDetails from "./postings-details";

export const transactionDetailComponents = {
  [JournalType.PAYMENTS]: PaymentsDetails,
  [JournalType.BANK_TRANSACTIONS]: BankingTransactionsDetails,
  [JournalType.BLOCKCHAIN_TRANSACTIONS]: BlockchainTransactionsDetails,
  [JournalType.BLOCKCHAIN_WITHDRAWALS]: BlockchainWithdrawalsDetails,
  [JournalType.FX_TICKETS]: FxTicketDetails,
  [JournalType.POSTINGS]: PostingsDetails,
} as const;

export {
  BankingTransactionsDetails,
  BlockchainTransactionsDetails,
  BlockchainWithdrawalsDetails,
  PaymentsDetails,
  FxTicketDetails,
  PostingsDetails,
};
